
        var i18n = require('cadenza/utils/i18n/i18n');
        module.exports = (function () {
          var messages = {"de":{"title.info":"Information","title.success":"Erfolg","title.warning":"Warnung","title.error":"Fehler","submit.button.ok":"OK"},"en":{"title.info":"Information","title.success":"Success","title.warning":"Warning","title.error":"Error","submit.button.ok":"OK"}};
          return function () {
            return i18n.loaderI18n.apply(messages[window.Disy.language], arguments);
          };
        })();